import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPut, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { BusinessSettings, UpdateBusinessSettingsDto } from '@/types/settings';

/**
 * Upsert the scheduler's per-tenant settings (slot duration, lead time,
 * buffers, travel-time toggle). Backend uses PUT for partial upsert — only
 * the keys present in the DTO get written.
 */
export function useUpdateBusinessSettings() {
  const queryClient = useQueryClient();

  return useApiMutation<BusinessSettings, UpdateBusinessSettingsDto>({
    mutationFn: (dto) =>
      apiPut<BusinessSettings, UpdateBusinessSettingsDto>(
        operationsClient,
        settingsEndpoints.updateBusinessSettings(),
        dto,
      ),
    onSuccess: (data) => {
      queryClient.setQueryData(settingsKeys.businessSettings(), data);
      toast.success('Business settings saved');
    },
  });
}
